import { render, staticRenderFns } from "./TeamName.vue?vue&type=template&id=281e5009&"
import script from "./TeamName.vue?vue&type=script&lang=js&"
export * from "./TeamName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports